import "./AccessDenied.scss";

const AccessDenied = ({
  title = "Access Denied",
  message = "You do not have the required permissions to view this page.",
}) => {
  return (
    <div className="access-denied">
      <div className="access-denied__card">
        <div className="access-denied__icon">🚫</div>
        <h1 className="access-denied__title">{title}</h1>
        <p className="access-denied__message">{message}</p>
      </div>
    </div>
  );
};

export default AccessDenied;